export default {
    productList: [
      {
            id: 7,
            img: require("@a/images/mosaic.png"),
            title: "八戒马赛克",
            dec: "八戒马赛克应用了AI识别技术：其核心算法包括人脸检测、车牌检测、聊天截图检测等，可用于对人脸与车牌进行打码处理",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
      },
      {
            id: 7,
            img: require("@a/images/fanji.png"),
            title: "饭记",
            dec: "饭记是一键拍照识别食物热量，快速测算卡路里、碳水、蛋白质与脂肪。极简无广告设计，轻松记录每日三餐",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 7,
            img: require("@a/images/sone_ai.png"),
            title: "Sone AI",
            dec: "Sone AI是创新科技与音乐艺术的完美结合体，它借助人工智能技术，实现音乐作品的创作、制作与改进，打破传统音乐创作局限，为音乐领域注入新活力",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 7,
            img: require("@a/images/traveler.png"),
            title: "网创旅行加",
            dec: "旅行加是一个提供旅游攻略和景点导航的便捷工具，助你轻松规划并探索旅途。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 17,
            img: require("@a/images/giginput.png"),
            title: "吉吉输入法",
            dec: "吉吉输入法，说话、说方言就能变成文字，文字点一下也能念给您听！\n",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 6,
            img: require("@a/images/honeytalk.png"),
            title: "网创蜜语坊",
            dec: "助力i人勇敢出击，告别纠结与犹豫，为你生成浪漫又独特的开场语，让你自信 say Hi。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 6,
            img: require("@a/images/holographicreallife.png"),
            title: "网创全息实景导航",
            dec: "网创全息实景导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 6,
            img: require("@a/images/busrealistic.png"),
            title: "网创公交实时导航",
            dec: "网创公交实时导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: require("@a/qrcode/3dword.png")
        },
        {
            id: 6,
            img: require("@a/images/3dsjjj_img.png"),
            title: "网创全景VR高清地图",
            dec: "一部手机就可以让你看遍世界了，世界任何角落都可以快速搜索到，可让您真切体验一下从城市上方飞过的感觉；3D地图实景功能让您尽情游览，完全以3D街景方式到达你想去的城市，集成到地球中的街景视图可让您穿街走巷、品味世界，您可以浏览到包括公路、边界、地点等在内的各种图层",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: require("@a/qrcode/3dword.png")
        },
        {
            id: 5,
            img: require("@a/images/clip.png"),
            title: "网创爆剪牛",
            dec: "爆剪牛是一款智能轻量化的视频剪辑软件，提供了便捷的视频剪辑交互操作功能，以及各种智能脚本和文案方便用户创作。爆剪牛最出色的功能则是提供了创作内容模板，简单几下就能复刻爆款视频，帮助用户快速流量变现。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 17,
            img: require("@a/images/isayinput_web.png"),
            title: "网创心语输入法",
            dec: "心语输入法是一款精心设计的支持语音播报文字的输入法，不识字、认字少的用户一定不要错过。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 17,
            img: require("@a/images/voice_input.png"),
            title: "网创智能点读输入法",
            dec: "智能点读输入法是一款精心设计的支持语音播报文字的输入法，不识字、认字少的用户一定不要错过。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 2,
            img: require("@a/images/lovehelp.png"),
            title: "网创恋爱帮帮忙",
            dec: "教你如何聊天的恋爱宝典。帮助恋爱中的男女在聊天时用更撩人的话术回复对方.",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 1,
            img: require("@a/images/realtimenav.png"),
            title: "网创实时地球导航",
            dec: "实时地球导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 1,
            img: require("@a/images/pathnav.png"),
            title: "网创实景路径导航",
            dec: "实景路径导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 1,
            img: require("@a/images/panorama.png"),
            title: "全景实况导航",
            dec: "全景实况导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 3,
            img: require("@a/images/realistic.png"),
            title: "实景卫星导航",
            dec: "实景卫星导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
    ]
}